import { css, keyframes } from "@emotion/react"

export default function WaveformIcon() {
  return (
    <div css={styles.container} aria-hidden="true">
      <div css={[styles.bar, styles.bar1]} />
      <div css={[styles.bar, styles.bar2]} />
      <div css={[styles.bar, styles.bar3]} />
      <div css={[styles.bar, styles.bar4]} />
    </div>
  )
}

const bounce = keyframes`
  0%, 100% { transform: scaleY(0.3); }
  50% { transform: scaleY(1); }
`

const styles = {
  container: css`
    display: flex;
    align-items: center;
    gap: 2px;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  `,
  bar: css`
    width: 2px;
    height: 100%;
    background-color: var(--d-icon-color-interaction);
    border-radius: 1px;
    transform-origin: bottom;
    animation: ${bounce} 1s ease-in-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      transform: scaleY(1);
    }
  `,
  bar1: css`
    animation-delay: 0s;
  `,
  bar2: css`
    animation-delay: -0.4s;
  `,
  bar3: css`
    animation-delay: -0.2s;
  `,
  bar4: css`
    animation-delay: -0.6s;
  `,
}
